import { type ReactNode } from 'react'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
} from '@/components/StickyViewHeader'
import { AvatarSelector } from '@/features/iam/users/components/AvatarSelector'
import { ViewHeading } from '@/components/ViewHeading'
import { useScrollOffsets } from '@/hooks/element-hooks'
import { ScrollView } from '@/components/ScrollView'

export interface TeamProps {
  teamName: string
  teamAvatar: string | null | undefined
  isUploadingPicture: boolean
  onSelectNewPicture: (file: File) => unknown
  tabBar?: ReactNode
  children?: ReactNode
}

export function Team({
  teamName,
  teamAvatar,
  isUploadingPicture,
  onSelectNewPicture,
  tabBar,
  children,
}: TeamProps) {
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()

  return (
    <ScrollView ref={scrollRef}>
      <StickyViewHeader scrollOffset={scrollOffset} tabBar={tabBar}>
        <StickyViewHeaderMain>
          <ViewHeading
            visual={
              <AvatarSelector
                size={48}
                isUploading={isUploadingPicture}
                onSelectNewFile={onSelectNewPicture}
                subject={{
                  avatar: teamAvatar,
                  displayName: teamName,
                }}
              />
            }
            primaryText="Teams"
            secondaryText={teamName}
          />
        </StickyViewHeaderMain>
      </StickyViewHeader>

      {children}
    </ScrollView>
  )
}
